<template>
    <div>
        <div class="text-right">
            <el-button type="primary" size="mini" @click="dialogVisible = true">
                Create Ingredient
            </el-button>
        </div>
        <el-dialog title="Create Ingredient" :visible.sync="dialogVisible">
            <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit('form')">
                <el-form-item label="Ingredient title" prop="title">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="Substitutes">
                    <el-input v-model="form.substitutes"></el-input>
                </el-form-item>
                <el-row :gutter="15">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Category" prop="category">
                            <el-select v-model="form.category" placeholder="Select a category">
                                <el-option v-for="category in categories" :key="category.slug" :label="category.title" :value="category.slug"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Language" prop="language">
                            <el-select v-model="form.language" placeholder="Select a language">
                                <el-option label="English" value="en"></el-option>
                                <el-option label="Malay" value="ms"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
                <el-button @click="onCancel('form')">Cancel</el-button>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            dialogVisible: false,
            form: {
                category: null,
                language: 'en',
                substitutes: null,
                title: null,
            },
            rules: {
                'language': [
                    { required: true, message: 'Select a language.', trigger: 'blur' },
                ],
                'title': [
                    { required: true, message: 'Enter the name of the ingredient.', trigger: 'blur' },
                ],
            },
            categories: [{
                title: 'Dry Herbs',
                slug: 'dry-herbs'
            }, {
                title: 'Fresh Herbs',
                slug: 'fresh-herbs'
            }, {
                title: 'Dry Seafood',
                slug: 'dry-seafood'
            }, {
                title: 'Fresh Seafood',
                slug: 'fresh-seafood'
            }, {
                title: 'Pickled Ingredients',
                slug: 'pickled-ingredients'
            }, {
                title: 'Sauces',
                slug: 'sauces'
            }, {
                title: 'Vegetables',
                slug: 'vegetables'
            }, {
                title: 'Tofu',
                slug: 'tofu'
            }],
        }
    },

    methods: {
        onSubmit(form) {
            this.loading = true

            this.$refs[form].validate(async valid => {
                if (!valid) {
                    this.loading = false

                    return false
                }

                try {
                    var { data } = await this.$http.post(`/ingredients`, {
                        category: this.form.category,
                        language: this.form.language,
                        title: this.form.title,
                        substitutes: this.form.substitutes,
                    })
                } catch(err) {
                    this.$message.error(err.response.data.message)

                    return false
                } finally {
                    this.loading = false
                }

                this.$router.push({ name: 'ingredients-id', params: { id: data.ingredient.id } })
                this.$message.success(data.message)
            })
        },

        onCancel(form) {
            this.dialogVisible = false
            this.$refs[form].resetFields()
        },
    },
}
</script>
